import styled from '@emotion/styled'
import { DEFAULT_FONT_STYLES, DEFAULT_THEME_COLORS } from 'css/theme'
import { UiIcon } from 'modules/ui/atoms/Icon'

export const StyledAccordionItem = styled.button`
  margin-bottom: 8px;
  border-radius: 12px;
  background: ${DEFAULT_THEME_COLORS['--theme-color--neutral-95']};

  width: 100%;
  border: none;
  text-align: left;
`

export const StyledAccordionItemHead = styled.div`
  display: flex;
  padding: 16px;
  cursor: pointer;
  align-items: center;
  color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-10']};
  font-weight: ${DEFAULT_FONT_STYLES['--theme-font--body-bold__font-weight']};
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-size']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--body-default__line-height']};
`

export const StyledAccordionItemHeadText = styled.div`
  flex: 1;
`

export const StyledAccordionItemHeadIcon = styled(UiIcon)``

export const StyledAccordionItemBody = styled.div<{ isOpen: boolean }>`
  color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-10']};
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--body-sm__font-size']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--body-sm__line-height']};
  padding: ${({ isOpen }) => (isOpen ? '0 16px 16px' : '0 16px')};

  // CSS trick to animate height between '0' and 'auto'
  display: grid;
  transition: 250ms all ease;
  grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
`

export const StyledAccordionItemBodyInner = styled.div`
  overflow: hidden;
`
